import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
/* Documentación: https://www.npmjs.com/package/react-pdf */
import { useParams } from "react-router-dom";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { useTranslatedData } from "../data/data.jsx";
import { globalT } from "../utils/globalUtils.js";
import i18next from "i18next";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function PdfViewer({ setInit }) {
  const { pdfId } = useParams();
  const currentLanguage = i18next.language;

  const data = useTranslatedData();

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    if (setInit) setInit(false);
  }, [setInit]);

  // El "texto de ejemplo" (goldText) no siempre es la primera opción del
  // género (suele ir tras el tutorial), así que lo buscamos por su clave.
  const genre = data.find((item) => item.id === pdfId);
  const goldText = genre?.options?.find((opt) => opt.goldText)?.goldText;
  const pdfUrl = goldText ? `/pdf/${currentLanguage}/${goldText}.pdf` : null;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToPreviousPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  const goToNextPage = () => {
    if (numPages && pageNumber < numPages) setPageNumber(pageNumber + 1);
  };

  if (!pdfUrl) {
    return (
      <div id="pdfContainer">
        <p className="m-subtitle">
          {globalT("No se pudo cargar el documento")}
        </p>
      </div>
    );
  }

  return (
    <div id="pdfContainer">
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<p className="m-subtitle">{globalT("Cargando")}…</p>}
        error={
          <p className="m-subtitle">
            {globalT("No se pudo cargar el documento")}
          </p>
        }
      >
        <Page
          pageNumber={pageNumber}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>

      <div className="pdf-toolbar">
        <a className="pdf-download" href={pdfUrl} download>
          {globalT("Descargar")}
        </a>

        {numPages > 1 && (
          <div className="pdf-pager">
            <button
              type="button"
              className="pdf-pager-btn"
              onClick={goToPreviousPage}
              disabled={pageNumber <= 1}
            >
              ‹ {globalT("Anterior")}
            </button>
            <span className="pdf-pager-info">
              {pageNumber} / {numPages}
            </span>
            <button
              type="button"
              className="pdf-pager-btn"
              onClick={goToNextPage}
              disabled={pageNumber >= numPages}
            >
              {globalT("Siguiente")} ›
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
